<template>
  <div class="max-w-[800px] mx-auto">
      <h1 class="font-nutino text-[30px] lg:text-[60px] font-extrabold text-center leading-[1.2]">
        {{ t('b2b.wellbeing.main.title') }}
      </h1>
      <p class="font-nutino text-[20px] lg:text-[30px] mt-4 text-center">
        {{ t('b2b.wellbeing.main.subtitle') }}
      </p>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();

</script>

